import React, { useState, useEffect } from 'react';
import styles from '../styles/wizards/AddPlanSettingTemplateWizard.scss';
import AddPlanIcon from '../assets/images/add-plan-60x60.svg';
import { __, validateForm } from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import * as _ from 'lodash';
import {
  createPlanSettingTemplates,
  listPlanSettingTemplates,
} from '../redux/actions/table/plan_setting_templates';
import AddPlanSettingTemplateForm from '../forms/add_plan_setting_template_wizard/AddPlanSettingTemplateForm';
import { connect } from 'react-redux';

const AddPlanSettingTemplateWizard = ({ match, onClose }) => {
  const _handleSubmit = (formData) => {
    return validateForm(
      createPlanSettingTemplates(match.params.stage, formData).then(() => {
        listPlanSettingTemplates(match.params.stage);

        onClose();

        setNotification(__('wizard.add-plan_setting-template.message.success'));
      })
    );
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>
            {__(
              'wizard.add-plan-setting-template.title.add-new-plan-setting-template'
            )}
          </span>
          <span>
            {__(
              'wizard.add-plan-setting-template.subtitle.add-new-plan-setting-template'
            )}
          </span>
        </div>
        <div className={styles.right}>
          <AddPlanIcon />
        </div>
      </div>
      <div className={styles.body}>
        <AddPlanSettingTemplateForm
          onSubmit={_handleSubmit}
          onClose={onClose}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    table: state.table['plan_setting_templates'],
  };
};

export default withRouter(
  connect(mapStateToProps, null)(AddPlanSettingTemplateWizard)
);
